/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { shallowEqual, useSelector } from "react-redux";
import { getSettingKey } from "../../../../../Common/utils";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import * as actions from "../../../../_redux/dashboard/dashboardActions";
import { formatNotificationDateTime } from "../notificationDateUtils";

export function DashboardNotificatonSection({ className , startDate, endDate}) {
  const { currentState } = useSelector((state) => ({ currentState: state.dashboard }), shallowEqual);
  const { totalCount, notificationEntities } = currentState;
  const { currentBasicState } = useSelector((state) => ({ currentBasicState: state.basicSettings }), shallowEqual);
  const timezone = getSettingKey(currentBasicState.entity, "Basic", "timezone");
  const history = useHistory();
  
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchNotifications({start_date: startDate, end_date: endDate}));
  }, [startDate, endDate]);


  return (
    <>
      <div className={`card card-custom  ${className}`}>
        {/* Header */}
        <div className="card-header align-items-center border-0 mt-4">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bolder text-dark">
              <FormattedMessage id="Notifications" defaultMessage="Notifications" />
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              {totalCount}
              <FormattedMessage id="Notifications" defaultMessage="Notifications" />
            </span>
          </h3>
          <div className="card-toolbar">
            <button
              type="button"
              onClick={() => {
                history.push(`/dashboard/notifications`);
              }}
              className="btn btn-primary text-weight-bold"
            >
              <FormattedMessage id="See All" defaultMessage="See All" />
            </button>
          </div>
        </div>
        <div className="m-6">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">
                  <FormattedMessage id="Date | Day" defaultMessage="Date" />
                </th>
                <th scope="col">
                  <FormattedMessage id="Time" defaultMessage="Time" />
                </th>
                <th scope="col">
                  <FormattedMessage id="Message" defaultMessage="Message" />
                </th>
              </tr>
            </thead>
            <tbody>
              {notificationEntities.slice(0, 7).map((notification) => {
                const { date: formattedDate, day, time: formattedTime } = formatNotificationDateTime(
                  timezone,
                  notification.created_at
                );
                return (
                  <tr>
                    <th>
                      {formattedDate} | {day}
                    </th>
                    <td>{formattedTime}</td>

                    <td>{notification.message}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
